import http from '@shared/http';
import {
  COSMOS_V1_URL, COSMOS_V2_URL, COSMOS_V3_URL
} from '@shared/const';
import {
  ProposalsDTO, ProposalsSpainResponse, ProposalsSearchParams
} from '@modules/proposals/api/dto/proposals.dto';
import { ProposalPreviewResponseDTO } from './dto/proposalPreview.dto';
import { CreateProposalESRequestDto, CreateProposalRequestDto } from './dto/createProposal.dto';
import { UpdateProposalRequestDto } from './dto/updateProposal.dto';
import { UpdateProposalConfigurationRequestDTO } from './dto/updateProposalConfiguration.dto';
import { DuplicateProposalResponseDto } from './dto/duplicateProposal.dto';
import { GetGovernmentFeesRequestDTO, GetGovernmentFeesResponseDTO } from './dto/getGovernmentFees';

const DEFAULT_LIMIT = 10;

export const proposalApi = {
  getProposals: (q: ProposalsSearchParams) => {
    const params = {
      q: q.q ?? '',
      page: q.page?.toString() ?? '',
      limit: q.limit.toString() ?? DEFAULT_LIMIT,
      sort: q.sort ?? '',
      order: q.order ?? '',
    };

    return http.get<ProposalsDTO>(`${COSMOS_V3_URL}/proposals/`, params);
  },

  getProposalsSpain: (q: ProposalsSearchParams) => {
    const params = {
      q: q.q ?? '',
      page: q.page?.toString() ?? '',
      limit: q.limit.toString() ?? DEFAULT_LIMIT,
      sort: q.sort ?? '',
      order: q.order ?? '',
    };

    return http.get<ProposalsSpainResponse>(`${COSMOS_V3_URL}/proposals/spain/`, params);
  },

  getProposalByExternalId: (id: string) => http.get<ProposalPreviewResponseDTO>(`${COSMOS_V3_URL}/proposals/${id}`),

  getProposalPreviewByExternalId: (proposalId: string) =>
    http.get<ProposalPreviewResponseDTO>(
      `${COSMOS_V3_URL}/proposals/${proposalId}/preview`
    ),

  requestDigitalProposalPdf: (html: string) =>
    http.post<Blob>(
      `${COSMOS_V2_URL}/document-service/html-to-pdf`,
      { html_content: html }
    ),

  createProposal: (payload: CreateProposalRequestDto) =>
    http.post<{ external_id: string }>(`${COSMOS_V3_URL}/proposals/`, payload),
  createProposalEs: (payload: CreateProposalESRequestDto) =>
    http.post<Blob>(`${COSMOS_V3_URL}/proposals/spain/`, payload),
  downloadProposalEs: ({ externalId }:{ externalId: string }) =>
    http.get<Blob>(`${COSMOS_V3_URL}/proposals/spain/${externalId}/download`, {}),
  updateProposal: (externalId: string, payload: UpdateProposalRequestDto) =>
    http.patch(`${COSMOS_V3_URL}/proposals/${externalId}`, payload),
  selectBankProducts: (externalId: string, bankProductsIds: string[]): Promise<{ bank_products_external_ids: string[] }> =>
    http.update(`${COSMOS_V3_URL}/proposals/${externalId}/bank-products`, { bank_products_external_ids: bankProductsIds }),
  updateProposalConfiguration: (externalId: string, payload: UpdateProposalConfigurationRequestDTO) =>
    http.patch(`${COSMOS_V3_URL}/proposals/${externalId}/config`, payload),
  duplicateProposal: (externalId: string) =>
    http.post<DuplicateProposalResponseDto>(`${COSMOS_V3_URL}/proposals/${externalId}/duplicate`, {}),
  getGovernmentFees: (payload: GetGovernmentFeesRequestDTO) =>
    http.get<GetGovernmentFeesResponseDTO>(`${COSMOS_V1_URL}/fees/calculate-government-fees`, payload),
};
